const DividerBlock = () => {
  return <hr className="divider-block" />;
};

export default DividerBlock;